/**
 * Korean translations
 */

export default {
  'Not included': '포함되지 않음',
  Included: '포함됨',
  Refresh: '새로고침',
  Unlimited: '무제한',
  'Pricing plans': '가격 책정 계획',
  'Select an option': '옵션 선택',
  'Play video': '동영상 재생',
  'Pause video': '동영상 일시 중지',
  // Add more translations here
}
